/*
 * @Author: edvardchen
 * @Date: 2017-09-27 18:41:24
 * @Last Modified by: edvardchen
 * @Last Modified time: 2018-03-20 23:11:02
 */

// @flow
import { type State, type Action, type Reducer } from './types';

export default (...reducers: Array<Reducer>) => (S: State, A: Action) =>
  reducers.reduce((prevState, func) => func(prevState, A), S);
